var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChaosinline = function SvgChaosinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#7D64FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 9.998a1 1 0 0 1 1 1v4.022a1 1 0 0 1-2 0v-1.558l-3.598 3.702c-.377.388-1.011.338-1.388-.05-.362-.37-.408-.971-.047-1.343l3.667-3.773h-1.657a1 1 0 1 1 0-2h4.022Zm-5.987 16.885c.378-.387 1.012-.437 1.388-.05L32 30.535v-1.558a1 1 0 0 1 2 0V33a1 1 0 0 1-1 1h-4.023a1 1 0 1 1 0-2h1.656l-3.666-3.772c-.362-.372-.316-.973.046-1.344ZM17.166 28.4c.387-.377.337-1.012-.05-1.389-.371-.362-.972-.407-1.344-.046L12 30.633v-1.657a1 1 0 1 0-2 0v4.023a1 1 0 0 0 1 1h4.021a1 1 0 0 0 0-2h-1.557l3.702-3.598Zm-.05-11.416c-.37.361-.971.407-1.343.046L12 13.364v1.657a1 1 0 1 1-2 0v-4.023a1 1 0 0 1 1-1h4.022a1 1 0 0 1 0 2h-1.558l3.702 3.598c.388.377.338 1.011-.05 1.389Zm9.384 5.013a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z",
    fill: "url(#chaos_inline_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chaos_inline_svg__a",
    x1: 21.743,
    y1: 15.698,
    x2: 21.743,
    y2: 33.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fff",
    stopOpacity: 0.8
  })))));
};
export default SvgChaosinline;